module.exports = __webpack_public_path__ + "img/18.ff2f6e91.png";